import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EliminaService } from 'src/app/services/elimina.service';

@Component({
  selector: 'app-elimina',
  templateUrl: './elimina.component.html',
  styleUrls: ['./elimina.component.css']
})
export class EliminaComponent implements OnInit {

  constructor(
    private Delete: EliminaService,
    private modalService: NgbModal,
    private globals: GlobalService,
    public activeModal: NgbActiveModal
  ) { }
  @Input() token;
  @Input() user;
  @Input() userOperator;
  @Input() contract;
  @Input() group;

  operator = false;
  contracts = false;
  _user = false;
  _group = false
  folder = false;


  ngOnInit() {
    this.change();
  }


  change() {

    if (this.contract) {
      this.contracts = true;
    }

    if (this.userOperator) {
      this.operator = true
    }

    if (this.user) {
      this._user = true;
    }

    if (this.group) {
      this._group = true;
    }
  }

  delete() {
    if (!this.folder) {
      if (this.user) {
        this.Delete.deleteCustomer(this.token, this.user.customer_id).subscribe(
          res => {
            this
            // this.activeModal.close(this.user.customer_id);
            this.folder = true;
            this._user = false;
          },
          err => {
            console.error("Errore in delOperator ", err);
          }
        )
      }
      if (this.userOperator) {
        this.Delete.deleteProfile(this.token, this.userOperator.user_id).subscribe(
          res => {
            this.activeModal.close(this.userOperator.user_id);
          },
          err => {
            console.error("Errore in delOperator ", err);
          }
        )
      }
      if (this.contracts) {
        this.Delete.deleteContract(this.token, this.contract.contract_id).subscribe(
          res => {
            this.activeModal.close(this.contract.contract_id);
          },
          err => {
            console.error("Errore in delContract ", err)
          }
        )
      }

      if (this.group) {
        this.Delete.deleteGroup(this.token, this.group.group_id, { alfesco_id: this.group.alfesco_id ? this.group.alfesco_id : [] }).subscribe(
          res => {
            console.log("entra", res);
            
            this.activeModal.close(this.group.group_id);
          },
          err => {
            console.error("Errore in delGroup ", err)
          }
        )
      }
    } else {
      this.Delete.delFolder(this.token, this.user.folder_id).subscribe(
        res => {
          this.activeModal.close(this.user.customer_id);
        }, err => {
          console.error("Errore in deleteFolder: ", err);
        }
      )
    }
  }

  mantieni() {
    this.activeModal.close(this.user.customer_id);
  }

  leave() {
    this.activeModal.close('cancel');
  }

}
